var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.model.isItemVisible(_vm.item),
          expression: "model.isItemVisible(item)",
        },
        {
          name: "key2click",
          rawName: "v-key2click",
          value: { processEsc: false, disableTabStop: _vm.item.disableTabStop },
          expression:
            "{ processEsc: false, disableTabStop: item.disableTabStop }",
        },
      ],
      key: _vm.item.id,
      class: _vm.model.getItemClass(_vm.item),
      attrs: {
        role: "option",
        id: _vm.elementId,
        "aria-selected": _vm.model.isItemSelected(_vm.item) ? "true" : "false",
        tabindex: _vm.item.disableTabStop ? -1 : 0,
      },
      on: { click: _vm.click },
    },
    [
      _vm.item.needSeparator
        ? _c("div", { class: _vm.model.cssClasses.itemSeparator })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.model.cssClasses.itemBody,
          style: _vm.model.getItemStyle(_vm.item),
          attrs: { title: _vm.item.locTitle.calculatedText },
          on: {
            mouseover: function (e) {
              return _vm.model.onItemHover(_vm.item)
            },
            mouseleave: function (e) {
              return _vm.model.onItemLeave(_vm.item)
            },
          },
        },
        [
          _vm.item.iconName && _vm.isDefaultItem
            ? _c("sv-svg-icon", {
                class: _vm.model.cssClasses.itemIcon,
                attrs: { iconName: _vm.item.iconName, size: _vm.item.iconSize },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDefaultItem
            ? _c("survey-string", { attrs: { locString: _vm.item.locTitle } })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.markerIconName
            ? _c("sv-svg-icon", {
                class: _vm.item.cssClasses.itemMarkerIcon,
                attrs: { iconName: _vm.item.markerIconName, size: "auto" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.popupModel && _vm.isDefaultItem
            ? _c("sv-popup", { attrs: { model: _vm.item.popupModel } })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.component
            ? _c(_vm.item.component, {
                tag: "component",
                attrs: { item: _vm.item },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }